import {
  CLEAN_ERRORS_QUOTE_BASIC_INFORMATION,
  CLEAN_QUOTE_SUCCESS,
  GET_COMPANY,
  GET_COMPANY_ERROR,
  GET_COMPANY_BIDDING_SUCCESS,
  GET_COMPANY_SELECTED_PROVIDERS_SUCCESS,
  GET_QUOTE_BASIC_INFO,
  GET_QUOTE_BASIC_INFO_ERROR,
  GET_QUOTE_BASIC_INFO_SUCCESS,
  TOGGLE_DIALOG_ALERT,
  UPDATED_STATUS_QUOTE_BID,
  CONTINADMISSIBLE,
  PAGE
} from './QuoteBasicInformation.actions'

const quoteState = {
  attachedFiles: [],
  basicInfo: {},
  bidding: [],
  bidsSeller: [],
  hostname: null,
  description: null,
  errors: [],
  institution: {},
  loading: false,
  openDialog: false,
  products: [],
  selectedProviders: [],
  statusCallAgile: {},
  paginationMeta: {},
  countInadmissible: 0,
  page: 0,
  purcharseOrderStatus: null
}

/**
 * The Quote Summary's reducer.
 */
const quoteBasicInformation = (state = quoteState, { payload, type }) => {
  switch (type) {
    case CLEAN_ERRORS_QUOTE_BASIC_INFORMATION: {
      return { ...state, errors: [] }
    }
    case CLEAN_QUOTE_SUCCESS: {
      return {
        ...quoteState
      }
    }
    case GET_COMPANY: {
      return { ...state, error: false }
    }
    case GET_QUOTE_BASIC_INFO: {
      return { ...state, loading: true, error: false }
    }
    case GET_COMPANY_ERROR: {
      return { ...state, error: true, errors: payload.errors }
    }
    case GET_QUOTE_BASIC_INFO_ERROR: {
      return { ...state, loading: false, error: true, errors: payload.error }
    }
    case GET_COMPANY_BIDDING_SUCCESS: {
      return {
        ...state,
        bidding: payload.company,
        error: false,
        errors: []
      }
    }
    case GET_COMPANY_SELECTED_PROVIDERS_SUCCESS: {
      return {
        ...state,
        selectedProviders: payload.company,
        loadingCompany: false,
        error: false,
        errors: []
      }
    }
    case GET_QUOTE_BASIC_INFO_SUCCESS: {
      return {
        ...state,
        basicInfo: payload.basicInfo,
        bidding: payload.bidding,
        bidsSeller: payload.bidsSeller,
        countInadmissible: payload.countInadmissible,
        countPurchaseCanceled: payload.countPurchaseCanceled,
        error: false,
        institution: payload.institution,
        loading: false,
        paginationMeta: payload.paginationMeta,
        products: payload.quoteProducts,
        purcharseOrderStatus: payload.purcharseOrderStatus,
        selectedProviders: payload.selectedProviders,
        statusCallAgile: payload.statusCallAgile
      }
    }
    case TOGGLE_DIALOG_ALERT: {
      return { ...state, openDialog: !state.openDialog }
    }
    case UPDATED_STATUS_QUOTE_BID: {
      const { bidId, status, inadmissibility } = payload

      if (state.bidding[bidId]) {
        return {
          ...state,
          bidding: {
            ...state.bidding,
            [bidId]: {
              ...state.bidding[bidId],
              statusBidId: status,
              inadmissibility
            }
          }
        }
      } else {
        return state
      }
    }
    case CONTINADMISSIBLE: {
      return {
        ...state,
        countInadmissible: payload
      }
    }
    case PAGE: {
      return {
        ...state,
        page: payload
      }
    }
    default: {
      return state
    }
  }
}

export default quoteBasicInformation
